import { ZfFilesUpload } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { DocumentDto } from '../../api/generated/client';
import { CLIENT_PACKAGE_DOCUMENT_TYPE } from '../../config/constants';
import type { IDocument } from '../../interfaces/document';
import type { IClientPackageAppendixDocument, IPackage, IPackageDocument } from '../../interfaces/package';
import { DocumentFileItemRow } from './DocumentFileItemRow';

interface IProps {
    packageId: IPackage['id'];
    additionalDocuments: IClientPackageAppendixDocument[];
    clientPackageDocuments: IPackageDocument[];
    documents: DocumentDto[];
    onUploadNewGenericDocuments: (packageId: IPackage['id'], files: File[]) => void;
    onDeleteAdditionalDocument: (genericDocument: IClientPackageAppendixDocument) => void;
    onRemoveClientPackageDocument: (docId: IDocument['id']) => void;
}

export const ClientPackageAdditionalDocuments: FunctionComponent<IProps> = ({
    packageId,
    additionalDocuments,
    clientPackageDocuments,
    documents,
    onUploadNewGenericDocuments,
    onDeleteAdditionalDocument,
    onRemoveClientPackageDocument,
}) => {
    const { t, i18n } = useTranslation();

    return (
        <div style={{ width: '100%', height: 'fit-content', paddingBottom: 'var(--padding-bottom-md)' }}>
            {additionalDocuments.map((document) => (
                <DocumentFileItemRow key={document.documentId} fileName={document.filename} onFileDelete={() => onDeleteAdditionalDocument(document)} />
            ))}
            {clientPackageDocuments.map((document) => (
                <DocumentFileItemRow
                    key={document.documentId}
                    fileName={documents.find((doc) => doc.id === document.documentId)?.name[i18n.language]}
                    onFileDelete={() => onRemoveClientPackageDocument(document.documentId)}
                />
            ))}
            <div
                style={{
                    height: '36px',
                    borderTop: '1px solid var(--border-color-default-normal)',
                    padding: 'var(--padding-top-xs) var(--padding-right-xl) 0 var(--padding-left-xl)',
                }}
            >
                <ZfFilesUpload
                    text={t('clientPackageGenericDocumentsActionUpload')}
                    size="extra-small"
                    hierarchy="tertiary"
                    accept={CLIENT_PACKAGE_DOCUMENT_TYPE}
                    onFileInputChange={(event: CustomEvent<File[]>) => onUploadNewGenericDocuments(packageId, event.detail)}
                />
            </div>
        </div>
    );
};
